import type { ReactElement } from 'react';
import { cloneElement, memo } from 'react';
import { useTheme } from 'styled-components';

import { NotificationIndicator } from '../../../../Elements/NotificationIndicator/index.tsx';
import { ItemHeaderWrapper, ItemIcon, ItemTitle, ItemTitleText, Label, NotificationIndicatorWrapper } from './styled.ts';

export type IconType = ReactElement<{ filled: boolean; color: string; size: number }>;

interface IHeaderWrapper {
  match: boolean;
  icon: IconType;
  title: string;
  label?: string;
  showIndicator?: boolean;
  isCollapsedNav?: boolean;
}

export const HeaderWrapper = memo(function HeaderWrapper({ match, icon, title, label, showIndicator, isCollapsedNav }: IHeaderWrapper) {
  const theme = useTheme();

  const clonedIcon = cloneElement(icon, {
    filled: !!match,
    color: match ? theme.colors.main : theme.colors.grey100_1,
    size: 20,
  });

  return (
    <>
      {showIndicator && isCollapsedNav && (
        <NotificationIndicatorWrapper>
          <NotificationIndicator warning />
        </NotificationIndicatorWrapper>
      )}
      <ItemHeaderWrapper>
        <ItemIcon>{clonedIcon}</ItemIcon>
        <ItemTitle>
          <ItemTitleText>{title}</ItemTitleText>
          {showIndicator && !isCollapsedNav && <NotificationIndicator warning />}
          {label && <Label>{label}</Label>}
        </ItemTitle>
      </ItemHeaderWrapper>
    </>
  );
});
